import React from 'react';
import styled from 'styled-components';
import { device } from '../../../common/breakpoints';
import { useAppSelector } from '../../../core/hooks';
import { cartStateSelector } from '../../../features/cart';
import CartCheckout from './CartCheckout';
import CartDetailsBody from './CartDetailsBody';
import CartDetailsHeader from './CartDetailsHeader';

const CartDetailsContent = () => {
  const { cart, isLoadingCart } = useAppSelector(cartStateSelector);
  const quantity = cart?.items.length ?? 0;
  const cartIsIncomplete = isLoadingCart || !quantity;

  return (
    <>
      <CartDetailsMain>
        <CartDetailsHeader />
        <CartDetailsBody />
      </CartDetailsMain>
      <CartDetailsFooter hidden={cartIsIncomplete}>
        <CartCheckout />
      </CartDetailsFooter>
    </>
  );
};

const CartDetailsMain = styled.div`
  padding: 24px 16px 0px 16px;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  overflow: hidden;
  ${device.mobile} {
    padding: 24px 24px 0px 24px;
  }
`;

const CartDetailsFooter = styled.div`
  padding: 16px;
  box-shadow: 0px -4px 7px 1px #0000001a;
  ${device.mobile} {
    padding: 24px;
  }
`;

export default CartDetailsContent;
